// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__YEJCr","maincontent":"Dashboard_maincontent__xI8DI"};